var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"w-full min-h-screen px-4 py-3 mb-3 bg-white rounded-md shadow-lg"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }